"use client";

import { useState, useEffect } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface TimezoneSelectProps {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const COMMON_TIMEZONES = [
  { value: "America/New_York", label: "Eastern Time (ET)", offset: "UTC-5/-4" },
  { value: "America/Chicago", label: "Central Time (CT)", offset: "UTC-6/-5" },
  { value: "America/Denver", label: "Mountain Time (MT)", offset: "UTC-7/-6" },
  {
    value: "America/Los_Angeles",
    label: "Pacific Time (PT)",
    offset: "UTC-8/-7",
  },
  {
    value: "America/Anchorage",
    label: "Alaska Time (AKT)",
    offset: "UTC-9/-8",
  },
  { value: "Pacific/Honolulu", label: "Hawaii Time (HST)", offset: "UTC-10" },
  { value: "UTC", label: "Coordinated Universal Time (UTC)", offset: "UTC+0" },
  {
    value: "Europe/London",
    label: "Greenwich Mean Time (GMT)",
    offset: "UTC+0/+1",
  },
  {
    value: "Europe/Paris",
    label: "Central European Time (CET)",
    offset: "UTC+1/+2",
  },
  {
    value: "Europe/Berlin",
    label: "Central European Time (CET)",
    offset: "UTC+1/+2",
  },
  {
    value: "Europe/Rome",
    label: "Central European Time (CET)",
    offset: "UTC+1/+2",
  },
  {
    value: "Europe/Madrid",
    label: "Central European Time (CET)",
    offset: "UTC+1/+2",
  },
  {
    value: "Europe/Amsterdam",
    label: "Central European Time (CET)",
    offset: "UTC+1/+2",
  },
  {
    value: "Europe/Stockholm",
    label: "Central European Time (CET)",
    offset: "UTC+1/+2",
  },
  {
    value: "Europe/Helsinki",
    label: "Eastern European Time (EET)",
    offset: "UTC+2/+3",
  },
  {
    value: "Europe/Athens",
    label: "Eastern European Time (EET)",
    offset: "UTC+2/+3",
  },
  {
    value: "Europe/Moscow",
    label: "Moscow Standard Time (MSK)",
    offset: "UTC+3",
  },
  { value: "Asia/Dubai", label: "Gulf Standard Time (GST)", offset: "UTC+4" },
  {
    value: "Asia/Karachi",
    label: "Pakistan Standard Time (PKT)",
    offset: "UTC+5",
  },
  {
    value: "Asia/Kolkata",
    label: "India Standard Time (IST)",
    offset: "UTC+5:30",
  },
  {
    value: "Asia/Dhaka",
    label: "Bangladesh Standard Time (BST)",
    offset: "UTC+6",
  },
  { value: "Asia/Bangkok", label: "Indochina Time (ICT)", offset: "UTC+7" },
  {
    value: "Asia/Singapore",
    label: "Singapore Standard Time (SGT)",
    offset: "UTC+8",
  },
  { value: "Asia/Hong_Kong", label: "Hong Kong Time (HKT)", offset: "UTC+8" },
  {
    value: "Asia/Shanghai",
    label: "China Standard Time (CST)",
    offset: "UTC+8",
  },
  { value: "Asia/Tokyo", label: "Japan Standard Time (JST)", offset: "UTC+9" },
  { value: "Asia/Seoul", label: "Korea Standard Time (KST)", offset: "UTC+9" },
  {
    value: "Australia/Sydney",
    label: "Australian Eastern Time (AET)",
    offset: "UTC+10/+11",
  },
  {
    value: "Australia/Melbourne",
    label: "Australian Eastern Time (AET)",
    offset: "UTC+10/+11",
  },
  {
    value: "Australia/Perth",
    label: "Australian Western Time (AWT)",
    offset: "UTC+8",
  },
  {
    value: "Pacific/Auckland",
    label: "New Zealand Time (NZST)",
    offset: "UTC+12/+13",
  },
];

export default function TimezoneSelect({
  value = "",
  onChange,
  placeholder = "Select timezone",
  className = "",
}: TimezoneSelectProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <div className={`h-10 border rounded-md bg-background ${className}`} />
    );
  }

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={className}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {COMMON_TIMEZONES.map((timezone) => (
          <SelectItem key={timezone.value} value={timezone.value}>
            <div className="flex flex-col">
              <span>{timezone.label}</span>
              <span className="text-xs text-muted-foreground">
                {timezone.value} ({timezone.offset})
              </span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
